// ags-line-slider-control-factory.ts
import { FlexiSlider } from "appworks/graphics/elements/flexi-slider";
import { SliderElement } from "appworks/graphics/elements/slider-element";
import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsLineSliderControl } from "../ags-line-slider-control";

export class AgsLineSliderControlFactory implements ControlFactory {
    
    /**
     * Returns true if the given layer contains all the required sprites and text fields for a line slider control.
     *
     * @param {Layers} layer - The layer to filter.
     * @returns {boolean} - True if the layer contains all the required sprites and text fields for a line slider control, false otherwise.
     */
    public filter(layer: Layers): boolean {
        return (
            layer.getSprite("line_slider_track") != null &&
            layer.getSprite("line_slider_fill") != null &&
            layer.getSprite("line_slider_handle") != null &&
            layer.getFlexiText("line_slider_label") != null
        );
    }


    /**
     * Builds a line slider control based on the given layer.
     *
     * @param {Layers} layer - The layer to build the control from.
     * @returns {AgsLineSliderControl[]} - An array of AgsLineSliderControl objects built from the given layer.
     */
    public build(layer: Layers): AgsLineSliderControl[] {
        const sliderElement = new SliderElement(
            layer,
            layer.getSprite("line_slider_track"),
            layer.getSprite("line_slider_fill"),
            layer.getSprite("line_slider_handle")
        );

        const slider = new FlexiSlider();
        slider.addTarget(sliderElement);

        const label = layer.getFlexiText("line_slider_label");
        return [new AgsLineSliderControl(slider, label)];
    }
}
